import PaymentProviders from "@/components/sites/PaymentProviders";
import { Explain } from "@/components/area/Explain";

// Client area · online payments: the owner connects their own Stripe account (Connect OAuth); MUSORA support can assist.
export default function AreaPayments({ tid, role, tenant }) {
  const support = role === "support";
  const canManage = support || (tenant?.perms || []).includes("payments.manage");
  return (
    <div className="space-y-4" data-testid="area-payments">
      <div>
        <h2 className="text-base font-semibold text-slate-900 md:text-lg">Pagamenti online</h2>
      </div>
      <Explain testid="payments-explain">Collega il tuo account Stripe per incassare online ordini, prenotazioni e abbonamenti: i soldi arrivano direttamente sul tuo conto Stripe. Il pagamento al ritiro e il bonifico restano disponibili come metodi aggiuntivi.</Explain>
      {!canManage && <p className="rounded-md bg-amber-50 p-3 text-xs text-amber-800" data-testid="area-payments-readonly">
        {role === "owner" ? "Per collegare Stripe o cambiare i metodi di pagamento attiva «Gestione operazioni dall'area cliente» in Team e permessi."
          : "Solo il titolare può collegare Stripe o cambiare i metodi di pagamento: qui vedi lo stato."}</p>}
      <PaymentProviders tid={tid} canManage={canManage} support={support} />
    </div>);
}
